import { render, staticRenderFns } from "./reportIMSNTSRatio.vue?vue&type=template&id=11e89fef&scoped=true&"
import script from "./reportIMSNTSRatio.vue?vue&type=script&lang=js&"
export * from "./reportIMSNTSRatio.vue?vue&type=script&lang=js&"
import style0 from "./reportIMSNTSRatio.vue?vue&type=style&index=0&id=11e89fef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e89fef",
  null
  
)

export default component.exports